/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ConfigurableBlockListItem_block$ref: FragmentReference;
export type ConfigurableBlockListItem_block = {|
  +id: string,
  +type: ConfigurableBlockType,
  +slug: ?string,
  +config: ?any,
  +active: ?boolean,
  +$refType: ConfigurableBlockListItem_block$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ConfigurableBlockListItem_block",
  "type": "ConfigurableBlock",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "config",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "active",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '05e503a9c69e9a5305e6c5df27f6677d';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/ConfigurableBlockListItem_block.graphql.js